import Vue  from 'vue';
import Vuex from 'vuex';

import state      from "./state";
import getters    from "./getters";
import mutations  from "./mutations";
import actions    from "./actions";
import user       from "./user/moduleUser";
import common     from "./common/index";
import * as axios from "@/axios/axios";

Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    appUser: user,
    common:  common,
  },
  strict:  process.env.NODE_ENV !== 'production',
});

axios.setStore(store);

export default store;
